(() => {
  function initMobileBottomNav() {
    const nav = document.querySelector('[data-vg-mobile-bottom-nav]');
    if (!nav || nav.dataset.vgReady === 'true') return;
    nav.dataset.vgReady = 'true';

    const menuButton = nav.querySelector('[data-vg-mobile-bottom-menu]');
    if (menuButton) {
      menuButton.addEventListener('click', () => {
        const summary = document.querySelector('header-drawer .header__icon--menu, .header__icon--menu');
        if (summary instanceof HTMLElement) {
          summary.click();
        }
      });
    }

    const cartButton = nav.querySelector('[data-vg-mobile-bottom-cart]');
    if (cartButton) {
      cartButton.addEventListener('click', (event) => {
        const headerCart = document.getElementById('cart-icon-bubble');
        if (headerCart instanceof HTMLElement && headerCart !== cartButton) {
          event.preventDefault();
          headerCart.click();
        }
      });
    }

    const items = nav.querySelectorAll('.vg-mobile-bottom-nav__item');
    const pageItem = nav.querySelector('[aria-current="page"]');
    const menuDetails = document.getElementById('Details-menu-drawer-container');
    const cartDrawer = document.querySelector('cart-drawer');

    // A drawer temporarily owns the selection; closing it restores the current page.
    function syncSelection() {
      const selected = cartDrawer?.classList.contains('active')
        ? cartButton
        : menuDetails?.classList.contains('menu-opening') ? menuButton : pageItem;
      items.forEach((item) => item.classList.toggle('is-active', item === selected));
      nav.dataset.vgSelectionReady = 'true';
    }

    const observer = new MutationObserver(syncSelection);
    [menuDetails, cartDrawer].forEach((drawer) => {
      if (drawer) observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    });
    window.addEventListener('pageshow', syncSelection);
    syncSelection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileBottomNav, { once: true });
  } else {
    initMobileBottomNav();
  }
})();
